import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const CITY_LINKS = [
  ["Paris", "paris"], ["Lyon", "lyon"], ["Marseille", "marseille"],
  ["Rouen", "rouen"], ["Évreux", "evreux"], ["Amiens", "amiens"],
];

export default function NotFound() {
  useEffect(() => {
    document.title = "404 — T'es perdu dans la zone | STUFF CBD";
    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.name = "robots";
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", "noindex, follow");
    return () => { robots.setAttribute("content", "index, follow"); };
  }, []);

  return (
    <div className="max-w-2xl mx-auto px-4 py-16 text-center" data-testid="not-found-page">
      <img src="/lion-portrait.webp" alt="Mascotte STUFF — lion perdu" className="mx-auto h-44 object-contain mb-6 opacity-90" loading="eager" />
      <p className="font-anton text-7xl sm:text-8xl neon-text-green leading-none mb-2">404</p>
      <h1 className="font-anton text-3xl sm:text-4xl uppercase text-white mb-3">T'es perdu dans la zone</h1>
      <p className="text-zinc-400 mb-8 max-w-md mx-auto">Cette page n'existe pas (ou plus). Pas de panique — le lion connaît tous les raccourcis du quartier.</p>
      <div className="flex flex-wrap gap-3 justify-center mb-10">
        <Link to="/" data-testid="notfound-home-btn" className="bg-neon-green text-black font-anton uppercase px-6 py-3 glow-green">← Retour au QG</Link>
        <Link to="/boutique/national" data-testid="notfound-national-btn" className="border border-neon-magenta text-neon-magenta font-anton uppercase px-6 py-3 hover:bg-neon-magenta hover:text-white transition-colors">Boutique nationale 📦</Link>
      </div>
      <p className="text-zinc-500 text-xs uppercase font-bold mb-3">Ou retrouve ton livreur :</p>
      <div className="flex flex-wrap gap-2 justify-center" data-testid="notfound-city-links">
        {CITY_LINKS.map(([name, slug]) => (
          <a key={slug} href={`/livraison-cbd/${slug}`} className="border border-zinc-700 text-zinc-300 text-xs font-bold uppercase px-3 py-1.5 hover:border-neon-green hover:text-neon-green transition-colors">{name}</a>
        ))}
      </div>
    </div>
  );
}
